var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{ref:"form",attrs:{"data":_vm.data,"save_text":_vm.save_text,"edit":_vm.edit},on:{"save":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }